// extracted by mini-css-extract-plugin
export default {"officialAccountAvatar":"OfficialAccountAvatar_officialAccountAvatar__KZdQm","logo":"OfficialAccountAvatar_logo__Wxt9J","avatar":"OfficialAccountAvatar_avatar__-paq4"};